import { Fragment, useEffect, useState } from "react";
import "./DraggableList.css";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import DraggableListItem from "./DraggableListItem";
import FieldNames from "../../defaults/FieldNames.json";
import { FixedSizeList } from "react-window";
import { ListItem } from "@mui/material";
import { makeStyles } from '@mui/styles';
import ColorConstants from "../../defaults/ColorConstants";
import { useWindowDimensions } from "../popover/BulkApprovalDialog/BulkApprovalDialog";
import { getListCard } from "../../utils/ListCardHelper";

export default function DraggableList({
  isAssociate,
  isInitialLoad,
  selectedFeatures,
  onDragEnd,
  handleRemoval,
  userInfo
}) {
  const [filteredItemList, setFilteredItemList] = useState([]);
  const { height } = useWindowDimensions();
  const isDraggable = true;
  const listCount = 200;

  const useStyles = makeStyles({
    draggingListItem: {
      background: 'rgb(235,235,235)',
      width: '550px',
      height: '300px',
      maxHeight: '300px'
    },
    listItem: {
      width: '550px',
      height: '300px',
      maxHeight: '300px',
    },
    saveSpace: {
      paddingTop: '0px!important'
    },
    saveSpaceCarryover: {
      paddingTop: '0px!important',
      backgroundColor: ColorConstants.CarryOver
    },
    padding: {
      padding: "0px 8px"
    }
  });
  const classes = useStyles();


  useEffect(() => {
    let filteredItems = selectedFeatures;
    if (!isAssociate && isInitialLoad) {
      filteredItems = selectedFeatures.sort((a, b) =>
        a[FieldNames.treatmentActivityGroupItems.sequenceNumber] >
        b[FieldNames.treatmentActivityGroupItems.sequenceNumber]
          ? 1
          : -1
      );
    }

    if (filteredItems && filteredItems.length > 0) {
      setFilteredItemList(filteredItems);
    }
  }, [isAssociate, isInitialLoad, selectedFeatures]);

  const Row = (props) => {
    const { index, style, data } = props;
    const { itemList } = data;
    
    let feature = null;
    if (itemList && itemList.length > 0) {
      feature = itemList[index];
      if(!feature)
      {
        return <Fragment></Fragment>;
      }

      return (
        <DraggableListItem
          style={style}
          selectedFeature={feature}
          index={index}
          handleRemoval={handleRemoval}
          isDraggable={isDraggable}
          userInfo={userInfo}
          key={
            index
          }
      />
      );
    } else {
      return <Fragment></Fragment>;
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable 
      droppableId="droppable-list" 
      mode='virtual'
      renderClone={(provided, snapshot, rubric, style) => (
        <ListItem
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={snapshot.isDragging ? classes.draggingListItem : classes.listItem}
            component="div"
          >
          {getListCard(
            rubric.source.index, 
            filteredItemList[rubric.source.index], 
            isDraggable, 
            userInfo,
            { 
              styleHeight: style?.height ? style.height - 5 : 165,
              styleWidth: style?.width ? style.width : 520,
              cardSizes: FieldNames.listCardTypes.detailed, 
              arrowListCard : 'list-normal', 
              backgroundClassListCard: filteredItemList[rubric.source.index][FieldNames.featureFields.isCarryover] === FieldNames.yesNo.yes ? classes.saveSpaceCarryover : classes.saveSpace, 
              classesListCard: classes.saveSpace,
              backgroundClass: classes.saveSpace
            },
            {
              objectId: null,
              onClicked: handleRemoval,
              selectedFeatures: selectedFeatures, 
              selectFeature: null, 
              createActual: null, 
              reportActual: null, 
              isGroupingsLoading: false, 
              onGroupEdit: null, 
            }
            )
          }
          </ListItem>
      )}>
        {(provided) => (
          <FixedSizeList
              height={height}
              width={550}
              itemCount={
                filteredItemList && filteredItemList.length > 0 ? filteredItemList.length : listCount
              }
              itemSize={170}
              overscanCount={5}
              itemData={{itemList: filteredItemList }}
              className="list-container"
              outerRef={provided.innerRef}
               {...provided.droppableProps}
            >
              {Row}
            </FixedSizeList>
        )}
      </Droppable>
    </DragDropContext>
  );
}